import { useState } from 'react';
import useRecaptchaTimer from './useRecaptchaTimer';
import useRecaptchaV2Widget from './useRecaptchaV2Widget';

const useAuthRecaptchaV2 = () => {
  const [showRecaptchaV2, setShowRecaptchaV2] = useState(false);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
  const [recaptchaV2Verified, setRecaptchaV2Verified] = useState(false);

  useRecaptchaTimer(() => {
    setShowRecaptchaV2(true);
    setIsSubmitDisabled(true);
  });

  const handleRecaptchaVerify = () => {
    setRecaptchaV2Verified(true);
    setIsSubmitDisabled(false);
  };

  useRecaptchaV2Widget(showRecaptchaV2, handleRecaptchaVerify);

  return { showRecaptchaV2, isSubmitDisabled, recaptchaV2Verified, handleRecaptchaVerify };
};

export default useAuthRecaptchaV2;
